import React, { Component } from 'react'
import { conditionalWidth } from '../utils/useful'

class SidebarView extends Component {

    state = {
        stage: 0,
        sideOpen: this.props.sideOpen ?? false
    }

    componentDidMount() {
        if (this.props.sideOpen) {
            this.setState({ showContent: true })
        }
    }

    openSidebar = (cb) => {
        this.open(cb)
    }

    closeSidebar = (cb) => {
        if (this.props.onSubClosed) {
            this.props.onSubClosed()
        }
        this.close(cb)
    }

    hideModal = (cb) => {
        this.close(cb)
    }

    open = (cb) => {
        this.setState({ sideOpen: true, showContent: true })
    }

    // closeSidebar = () => {
    //     this.setState({ sideOpen: false })
    //     if(this.props.onClosed){
    //         this.props.onClosed()
    //     }
    // }

    // open = () => {
    //     this.setState({ sideOpen: true })
    // }

    // close = () => {
    close = (cb) => {
        this.setState({ sideOpen: false })
        setTimeout(() => {
            if (!this.state.sideOpen) {
                this.setState({ showContent: false })
            }
            if (this.props.onClosed) {
                this.props.onClosed()
            }
        }, 400);
    }

    render() {
        return (
            <div >
                {!this.props.hideOverlay && (
                    <div onClick={() => { this.closeSidebar() }} className={'sidePanel-overlay position-fixed top-0  h-100 fadein ' + (this.state.sideOpen ? '' : 'd-none')} style={{ left: this.props.isMobile ? 0 : this.props.left, zIndex: 30, width: this.props.isMobile ? '100%' : 'calc(100% - 50px)', backgroundColor: '#10101090', borderRadius: 10 }}>
                    </div>
                )}
                <div className={"sidePanel " + (conditionalWidth(this.props.width, { xs: '', lg: ' ' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ zIndex: this.props.zIndex ?? 30, paddingTop: this.props.paddingTop, left: this.props.isMobile ? 0 : this.props.left, width: (this.props.widthImport ?? conditionalWidth(this.props.width, (this.props.widthCondition ?? { xs: '80%', md: '200px' }))) }}>
                    <div className='sidePanel-content h-100 ' style={{ backgroundColor: '#fff' }} >
                        {this.state.showContent && (
                            <div className='w-100 h-100' style={this.props.updatePos ? { overflow: 'auto' } : {}}>
                                {this.props.children}
                            </div>
                        )}
                        {this.props.isDesktop &&
                            <button className={"close-hide sideHandler  flexcc "} onClick={this.closeSidebar}>
                                <img src="/images/next-2.png" width="20px" alt="" />
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default (SidebarView);